import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    PENDING,
    VALIDATED,
    CANCELED,
    INSUFFICIENT_FOUND,
    WAITING_TRANSACTION
} from '../../../../services/checkout/constants';
import { PATH } from '../../../../constants/path';
import { MODAL_TYPE_KYC } from '../../../../services/modal/constants';
import { APPLICATION_ID, REDIRECT_URL } from '../../../../constants';
import { KYC_USE_CASE_WAITING_TRANSACTION } from '../../../../services/kyc/constants';

import { showModal } from '../../../../services/modal/actions';
import { fetchPaypalDetails } from '../../../../services/paypal/actions';
import { fetchCheckoutDetails } from '../../../../services/checkout/actions';
import { fetchEbonOrderByIdWithCode } from '../../../../services/ebon/actions';

import { redirectParent } from '../../../../utils';

import { useTracking } from '../../../../tracking/provider';

const ConfirmationEbonPageStateController = ({
    orderId,
    partnerId,
    partnerName,
    checkoutSessionId,
    checkoutPaymentId,
    paypalCost,
    paymentRef,
    setLoading,
    setKyc,
    kycValidated,
    ebonOrderState,
    setEbonOrderState,
    detailsInterval,
    sessionEmail,
    history,
    fetchingOrder,
    fetchingCheckoutDetails,
    checkoutDetails,
    confirmedOrderState,
    fetchingPaypalDetails,
    paypalDetails,
    fetchEbonOrderByIdWithCode,
    fetchCheckoutDetails,
    fetchPaypalDetails,
    showModal
}) => {
    const [pendingInterval, setPendingInterval] = useState(null);

    const { gtm, ready } = useTracking();

    const isPaypalPayment = !!paypalCost;
    // CB, Apple Pay et Google Pay passent par Checkout et peuvent revenir sans paramètre cko-* : Checkout par défaut
    const isCheckoutPayment = !isPaypalPayment && !!orderId;

    const fetchDetails = () => {
        if (isCheckoutPayment) {
            fetchCheckoutDetails(orderId, checkoutPaymentId);
        } else if (isPaypalPayment) {
            fetchPaypalDetails(paymentRef);
        }
    };

    /* Handle loading */
    useEffect(() => {
        // sans état PSP (retour sans paramètre cko-*), l'état de la commande suffit
        const orderAlreadyValidated = confirmedOrderState === VALIDATED;

        if (
            fetchingOrder ||
            fetchingCheckoutDetails ||
            fetchingPaypalDetails ||
            (!ebonOrderState && !orderAlreadyValidated) ||
            ebonOrderState === PENDING
        ) {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [
        fetchingOrder,
        fetchingCheckoutDetails,
        fetchingPaypalDetails,
        ebonOrderState,
        confirmedOrderState
    ]);

    /* Fetch order on display */
    useEffect(() => {
        fetchEbonOrderByIdWithCode(orderId);
    }, []);

    /* Fetch order state on display */
    useEffect(() => {
        fetchDetails();
    }, [checkoutSessionId, paypalCost]);

    /* Set order state */
    useEffect(() => {
        if (isPaypalPayment) {
            return setEbonOrderState(paypalDetails);
        } else {
            return setEbonOrderState(checkoutDetails);
        }
    }, [checkoutDetails, paypalDetails]);

    /* Handle order states */
    useEffect(() => {
        if (!ebonOrderState || ebonOrderState === PENDING) {
            if (!pendingInterval) {
                setPendingInterval(
                    setInterval(() => {
                        fetchDetails();
                    }, 5000)
                );
                return () => {
                    clearInterval(pendingInterval);
                };
            }
        }

        if (!kycValidated && ebonOrderState && ebonOrderState === WAITING_TRANSACTION) {
            clearInterval(pendingInterval);
            clearInterval(detailsInterval);
            setKyc(true);
            showModal(MODAL_TYPE_KYC, {
                hideCloseButton: true,
                useCase: KYC_USE_CASE_WAITING_TRANSACTION
            });
        }

        if (ebonOrderState === CANCELED || ebonOrderState === INSUFFICIENT_FOUND) {
            clearInterval(pendingInterval);
            clearInterval(detailsInterval);
            history.push(`${PATH.EBON_ERROR_PATH}-${partnerId}?paiement=error&orderId=${orderId}`);
        }

        if (ebonOrderState === VALIDATED) {
            ready &&
                gtm.event('purchase', {
                    partner: { name: partnerName, id: partnerId },
                    orderId,
                    email: sessionEmail
                });
            clearInterval(pendingInterval);
            clearInterval(detailsInterval);

            if (REDIRECT_URL) {
                if (APPLICATION_ID === '142') {
                    setTimeout(() => {
                        redirectParent(REDIRECT_URL);
                    }, 10000);
                } else {
                    redirectParent(REDIRECT_URL);
                }
            }
        }
    }, [ebonOrderState]);

    return null;
};

ConfirmationEbonPageStateController.propTypes = {
    orderId: PropTypes.string,
    partnerName: PropTypes.string,
    partnerId: PropTypes.number,
    checkoutSessionId: PropTypes.string,
    checkoutPaymentId: PropTypes.string,
    paypalCost: PropTypes.string,
    paymentRef: PropTypes.string,
    setLoading: PropTypes.func,
    setKyc: PropTypes.func,
    kycValidated: PropTypes.bool,
    ebonOrderState: PropTypes.string,
    confirmedOrderState: PropTypes.string,
    setEbonOrderState: PropTypes.func,
    detailsInterval: PropTypes.number,
    sessionEmail: PropTypes.string
};

const mapStateToProps = state => {
    return {
        fetchingOrder: state.ebon.fetchOrder,
        fetchingCheckoutDetails: state.checkout.fetchingDetails,
        checkoutDetails: state.checkout.details ? state.checkout.details.ebonOrderState : null,
        confirmedOrderState: state.ebon.confirmedOrder ? state.ebon.confirmedOrder.state : null,
        fetchingPaypalDetails: state.paypal.fetchingDetails,
        paypalDetails: state.paypal.details ? state.paypal.details.ebonOrderState : null
    };
};

const mapDispatchToProps = {
    fetchEbonOrderByIdWithCode,
    fetchCheckoutDetails,
    fetchPaypalDetails,
    showModal
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ConfirmationEbonPageStateController)
);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/ConfirmationEbonPageStateController.js